<template>
  <div id="profitInter" class="search">
    <Row>
      <Col>
        <Card>
          <Row :lazy="true" :gutter="5">
              <Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">
              <infor-card id-name="user_created_count" :end-val="bcount.yesterdayIncomeTotal" iconType="md-person-add" color="#2d8cf0" intro-text="昨日收益"></infor-card>
              </Col>
              <Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">
              <infor-card id-name="visit_count" :end-val="bcount.yesterdayPlayCountTotal" iconType="ios-eye" color="#64d572" :iconSize="50" intro-text="昨日播放量"></infor-card>
              </Col>
              <Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">
              <infor-card number="2" id-name="collection_count" :end-val-two="bcount.playCountTotal" :end-val="bcount.incomeTotal" iconType="md-cloud-upload" color="#ffd572" intro-text="总收益"  intro-text-two="总播放量"></infor-card>
              </Col>
          </Row>
          <Row @keydown.enter.native="handleSearch">
            <Form id="search-form-y" ref="searchForm" :model="searchForm" inline :label-width="100" class="search-form">
              <Form-item label="平台" prop="mediaPlatform">
                <Input type="text" v-model="searchForm.mediaPlatform" placeholder="请输入发布平台" clearable style="width: 200px"/>
              </Form-item>
              <FormItem label="版权方名称" prop="copyrightVendorName" >
                <Select v-model="searchForm.copyrightVendorName" placeholder="请选择" style="width: 200px" @on-change='changeId' :label-in-value='true'>
                    <Option style="height:30px" v-for="(item, i) in copyrightVendorNames" :key="i" :value="item.id">
                      {{item.copyrightVendorName}}</Option>
                  </Select>
              </FormItem>
              <Form-item label="收益分析筛选" prop="copyrightName"> 
                <Select :label-in-value="true" @on-change="copyTypeChange" v-model="searchForm.copyrightName" placeholder="请选择" style="width: 200px;margin-left:20px;">
                  <Option v-for="(item, i) in dictTime" :key="i" :value="item.copyright_name">{{item.copyright_name}}</Option>
                </Select>
              </Form-item>
              <Button style="margin-left:20px;margin-bottom:20px;" @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
              <Button style="margin-left:20px;margin-bottom:20px;" @click="addExcel" type="primary" icon="md-add">分发导入</Button>
            </Form>
          </Row>
          <Row>
            <Col :md="24" :lg="24" style="padding:0px 20px 20px;" >
                <div>
                    最近收益曲线
                    <Select @on-change="numberDayChange(model1)" v-model="model1" placeholder="请选择天数" style="width: 200px;margin-left:50px;">
                        <Option v-for="(item, i) in dictTimeDay" :key="i" :value="item.value">{{item.title}}</Option>
                    </Select>
                </div>
            </Col>
            <Col :md="24" :lg="24" :style="{padding:'0px 20px',display:myHeightLine==0?'none':'block'}" >
                <tort-line-chart type="line1" ref="tortLineChartSy" :numberD="numberD" id="tortLineChartSy" :lengend="lengendLine" :xAxis="xAxisLine" :series="seriesLine" :maxVal="maxValLine"></tort-line-chart>
            </Col>
            <!-- <Col :md="24" :lg="24" :style="{padding: '0px 0 10px 50px',display:myHeightPie==0?'none':'block'}">
                <div>
                     <line-chart></line-chart>
                    <tort-chart ref="tortChartsSy" :legend="lengendPie" :series="seriesPie" :numberD="numberD" id="tortChartsSy" title="收益分布统计饼图"></tort-chart>
                </div>
            </Col> -->
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalExcelTitle" v-model="modalExcelVisible" :mask-closable='false' :width="500">
      <Form ref="excelform" :model="excelform" :label-width="100" :rules="formExcelValidate" >        
        <FormItem label="文件上传控件" prop="excelFile">
          <input id="fileupload" type="file"  name="file" accept=".xlsx,.xls" @change="uploadFile">
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalExcelVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleExcelSubmit">提交</Button>
      </div>
    </Modal>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        
        <FormItem label="标题" prop="title" >
          <Input v-model="form.title" style="width:100%"/>
        </FormItem>
        <FormItem label="发布平台" prop="mediaPlatform" >
          <Input v-model="form.mediaPlatform" style="width:100%"/>
        </FormItem>
        <FormItem label="自媒体账号" prop="wemediaAccountCode" >
          <Input v-model="form.wemediaAccountCode" style="width:100%"/>
        </FormItem>
        <FormItem label="连接" prop="linkUrl" >
          <Input v-model="form.linkUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="播放量" prop="playCount" >
          <Input v-model="form.playCount" style="width:100%"/>
        </FormItem>
        <FormItem label="版权名" prop="copyrightName" >
          <Input v-model="form.copyrightName" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {excelImport, copyrightTotalGetTotal, copyrightGetAll, getAllcopyrightVendorList} from "@/api/index";
import lineChart from "./../../home/components/lineChart.vue"; 
import tortChart from "./../../home/components/tortChart.vue";
import tortLineChart from "./../../home/components/tortLineChart.vue";
import inforCard from "./../../home/components/inforCard.vue";
export default {
  name: "profit-analyze",
  components: {
    tortLineChart,
    lineChart,
    tortChart,
    inforCard,
  },
  data() {
    return {
      selectA:'selectA',
      selectB:'selectB',
      lengendLine:[],
      // xAxisLine:['2019-10-18','2019-10-19','2019-10-20','2019-10-21','2019-10-22','2019-10-23','2019-10-24','2019-10-25','2019-10-26','2019-10-27','2019-10-28','2019-10-29','2019-10-30','2019-10-31','2019-11-1','2019-11-2','2019-11-3','2019-11-4','2019-11-5','2019-11-6','2019-11-7','2019-11-8','2019-11-9','2019-11-10','2019-11-11','2019-11-12','2019-11-13','2019-11-14','2019-11-15','2019-11-16'],
      seriesLinesum:[{
            name:'收益',
            type:'line',
            data:[12000, 14900, 17000, 12320, 12560, 17670, 13500, 16204, 13260, 18217, 16405, 11338, 12083, 14970, 14705, 12893, 18256, 17627, 19356, 16022, 18326, 18200, 14105, 17324,18008, 19409, 15726, 19232, 15606, 16702]
        }],
      xAxisLine:[],
     seriesLine:[{
              name:'收益',
              type:'line',
              data:[17324,18008, 19409, 15726, 19232, 15606, 16702]
          }],
      maxValLine:'25000',
      lengendPie:['今日头条','趣头条','网易新闻','一点资讯','百家号','爱奇艺号','优酷视频','Bilibili','UC大鱼号','其他'],
      seriesPie:[{value:335, name:'今日头条'},
     {value:310, name:'趣头条'},
     {value:234, name:'网易新闻'},
     {value:135, name:'一点资讯'},
     {value:1548, name:'百家号'},
     {value:1335, name:'爱奇艺号'},
     {value:2335, name:'优酷视频'},
     {value:3335, name:'Bilibili'},
     {value:4335, name:'UC大鱼号'},
     {value:5335, name:'其他'}],
    //  xAxisLine:[],
    //  seriesLine:[],
    //  maxValLine:'',
    //  lengendPie:[],
    //  seriesPie:[],
     pageNumberD:1,
      copyrightVendorNameD:'',
      copyrightNameD:'',
      myHeightLine:'417px',
      myHeightPie:'357px',
      dictTime:[],
      copyrightVendorNames:[],
      dictTimeDay:[
         {value:'7',title:'七天'},
         {value:'14',title:'十四天'}, 
         {value:'30',title:'三十天'}, 
      ],
      model1:'7',
      numberD:'7',
      bcount:{
          copyrightTotal: 485,
          incomeTotal: 473924,
          playCountTotal: 84264135,
          yesterdayIncomeTotal: 1670,
          yesterdayPlayCountTotal: 3687802,
      },
      // bcount:{
      //     copyrightTotal: 0,
      //     incomeTotal: 0,
      //     playCountTotal: 0,
      //     yesterdayIncomeTotal: 0,
      //     yesterdayPlayCountTotal: 0,
      // },
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      modalExcelVisible: false, // 添加或编辑显示
      modalExcelTitle: "", // 添加或编辑标题
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "create_time", // 默认排序字段
        order: "desc", // 默认排序方式
        copyrightName:'',
        copyrightVendorName:'',
      },
      form: { // 添加或编辑表单对象初始化数据
        title: "",
        mediaPlatform: "",
        wemediaAccountCode: "",
        linkUrl: "",
        playCount: "",
        copyrightName: "",
      },
      // 表单验证规则
      formValidate: {
      },
      excelform:{
        excelFile:''
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "标题",
          key: "title",
          minWidth: 240,
          sortable: false,
          render: (h, params) => {
            return h("div", [
              h("a",
                {
                  on: {
                    click: () => {
                      this.goUrl(params.row.linkUrl);
                    }
                  }
                },
                params.row.title
              )
            ])
          }
        },
        {
          title: "发布平台",
          key: "mediaPlatform",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "自媒体账号",
          key: "wemediaAccountCode",
          minWidth: 120,
          sortable: false,
        },
        // {
        //   title: "连接",
        //   key: "linkUrl",
        //   minWidth: 120,
        //   sortable: false,
        //   render: (h, params) => {
        //     return h("div", [
        //       h("a",
        //         {
        //           on: {
        //             click: () => {
        //               this.goUrl(params.row.linkUrl);
        //             }
        //           }
        //         },
        //         params.row.linkUrl
        //       )
        //     ])
        //   }
        // },
        {
          title: "播放量",
          key: "playCount",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "版权名",
          key: "copyrightName",
          minWidth: 120,
          sortable: false,
        },
      ],
      data: [], // 表单数据
      total: 0, // 表单数据总数
      copyrightVendorId:'',
    };
  },
  methods: {
    changeId(v){
      if(v.label.trim()=='全部'){
        this.copyrightVendorNameD = ''
        this.copyrightVendorId = ''
        this.copyrightNameD = ''
        this.searchForm.copyrightName = ''
      }else{
        this.copyrightVendorNameD = v.label.trim()
        this.copyrightVendorId = v.value.trim()
        this.copyrightNameD = ''
        this.searchForm.copyrightName = ''
      }
      this.goProfitAnalyzeList();
      // this.getBzChartList();
      this.getBqChartList();
      this.getDataList();
    },
    // 获取版权方的数据
    getAllcopyrightVendorList(){
      getAllcopyrightVendorList({}).then(res =>{
        if(res.success){
          console.log(res.result)
          let results = res.result
          for(let i of results){
            i.value = i.id
          }
          let midArray = [
            {
              value:'',
              id:'',
              copyrightVendorName:'全部',
            }
          ]
          this.copyrightVendorNames = midArray.concat(res.result);
        }
      })
    },
    // 获取收益预估分析的列表
    goProfitAnalyzeList(){
      let copyrightVendorId = this.copyrightVendorId
      this.postRequest("/incomeAnalyse/getCopyrightList", {copyrightVendorId:copyrightVendorId}).then(res => {
        let results = res
          for(let i of results){
            i.value = i.id
          }
        this.dictTime = res
      });
    },
    goUrl(url){
      window.open(url,'_blank')
    },
    // 收益分析调用折线图
    getBqChartList(){
        let _this = this;
        _this.$nextTick(() => {
          let params = {
              dayNum:_this.numberD,
              copyrightVendorName:_this.copyrightVendorNameD,
              copyrightName:_this.copyrightNameD
          }
          if(!_this.copyrightVendorNameD){
              delete params.copyrightVendorName
          }
          if(!_this.copyrightNameD){
              delete params.copyrightName
          }
          _this.$nextTick(() => {  
            _this.$refs.tortLineChartSy.tortChart();
          })
          // _this.getRequest("/copyrightTotal/getCopyrightIncomeBrokenLine",params).then(res => {
          //     console.log(res)
          //     if(Object.keys(res).length>0){
          //       _this.myHeightLine = 1;
          //       _this.lengendLine = res.legend
          //       _this.xAxisLine = res.xAxis
          //       _this.seriesLine =   res.series
          //       _this.maxValLine =   res.maxVal
          //       _this.$set(_this.lengendLine,_this.lengendLine,res.legend)
          //       _this.$set(_this.xAxisLine,_this.xAxisLine,res.xAxis)
          //       _this.$set(_this.seriesLine,_this.seriesLine,res.series)
          //       _this.$nextTick(() => {  
          //         _this.$refs.tortLineChartSy.tortChart();
          //       })
          //     }else{
          //         _this.myHeightLine = 0;
          //     }
          // });
        })
    },
    // 收益分析调用饼状图
    getBzChartList(){
        let _this = this;
        _this.$nextTick(() => {
            let params = {
                copyrightName:_this.copyrightNameD,
                copyrightVendorName:_this.copyrightVendorNameD,
            }
            if(!_this.copyrightVendorNameD){
                delete params.copyrightVendorName
            }
            if(!_this.copyrightNameD){
                delete params.copyrightName
            }
            _this.$nextTick(() => {  
              _this.$refs.tortChartsSy.tortChart();
            })
            // _this.getRequest("/copyrightTotal/getCopyrightIncomePie",params).then(res => {
            //     if(Object.keys(res).length>0){
            //         _this.myHeightPie = 1;
            //         _this.lengendPie = res.legend
            //         _this.seriesPie = res.series
            //         _this.$set(_this.lengendPie,_this.lengendPie,res.legend)
            //       _this.$set(_this.seriesPie,_this.seriesPie,res.series)
            //       _this.$nextTick(() => {  
            //         _this.$refs.tortChartsSy.tortChart();
            //       })
            //     }else{
            //         _this.myHeightPie = 0;
            //     }
            // });
        })
    },
    copyTypeChange(v){
      console.log('888888888888888888888888',v)
      this.copyrightNameD = v?v.label.trim():''
        // this.searchForm.copyrightType = v.label
        // this.getBzChartList();
        console.log('+++++++++++++++++++++++++',this.copyrightNameD)
      this.$nextTick(() => {
        this.getBqChartList();
        this.getDataList();
      })
    },
    numberDayChange(v){
      this.numberD = v
      switch(this.numberD){
        case '7':
          this.xAxisLine=this.getAutoDate(7)
          this.seriesLine=[{
              name:'收益',
              type:'line',
              data:[17324,18008, 19409, 15726, 19232, 15606, 16702]
          }];
          break;
        case '14':
          this.xAxisLine=this.getAutoDate(14)
          this.seriesLine=[{
              name:'收益',
              type:'line',
              data:[18256, 17627, 19356, 16022, 18326, 18200, 14105, 17324,18008, 19409, 15726, 19232, 15606, 16702]
          }];
          break;
        case '30':
          this.xAxisLine=this.getAutoDate(30)
          this.seriesLine=[{
              name:'收益',
              type:'line',
              data:[12000, 14900, 17000, 12320, 12560, 17670, 13500, 16204, 13260, 18217, 16405, 11338, 12083, 14970, 14705, 12893, 18256, 17627, 19356, 16022, 18326, 18200, 14105, 17324,18008, 19409, 15726, 19232, 15606, 16702]
          }];
          break;
        default:
          break;
      }
      this.getBqChartList();
    },
    // 自动获取时间的函数
    getAutoDate(number){
      let dateArray = []
      for(let i=0;i<number;i++){
        dateArray
        .unshift(this.time(new Date(new Date()
           .setDate(new Date().getDate()-i))
           ))
      }
      return dateArray
      console.log('+++++++++++++++++',dateArray)
    },
    time(date){
        var y = date.getFullYear();  
        var m = date.getMonth() + 1;  
        m = m < 10 ? '0' + m : m;  
        var d = date.getDate();  
        d = d < 10 ? ('0' + d) : d;  
        return y + '-' + m + '-' + d;  
    },
    init() {
      this.xAxisLine = this.getAutoDate(7)
      let yesterdayTime = this.time(new Date())
      let tempYes = this.xAxisLine
      let sumLength = this.seriesLinesum[0].data.length - tempYes.length;
      let count = 0
      let aaa = this.seriesLinesum[0].data
      for(let j=0;j<aaa.length;j++){
        count += parseInt(aaa[j])
        console.log('88888888888888888888',count)
      }
      for(let i = 0;i<tempYes.length;i++){
        if(tempYes[i] == yesterdayTime){
          if(sumLength+i-1>=0){
            this.bcount.yesterdayIncomeTotal = this.seriesLinesum[0].data[sumLength+i-1]
            this.$set(this.bcount,'yesterdayIncomeTotal',this.seriesLinesum[0].data[sumLength+i-1])
          }else{
            this.bcount.yesterdayIncomeTotal = 0
            this.$set(this.bcount,'yesterdayIncomeTotal',0)
          }
        }
      }
      this.goProfitAnalyzeList();
      this.getAllcopyrightVendorList();
      this.getDataList();
      // this.getDataShow();
      this.getBqChartList();
      // this.getBzChartList();
      // copyrightGetAll({}).then(res => {
      // })
    },
    getDataShow(){
      let params = {
        copyrightName:this.copyrightNameD,
        copyrightVendorName:this.copyrightVendorNameD
      }
      copyrightTotalGetTotal(params).then(res => {
        let incomeTotal = res.incomeTotal == '' || res.incomeTotal == null || res.incomeTotal == undefined ? 0 :res.incomeTotal;
        let copyrightTotal = res.copyrightTotal == '' || res.copyrightTotal == null || res.copyrightTotal == undefined ? 0 :res.copyrightTotal;
        let playCountTotal = res.playCountTotal == '' || res.playCountTotal == null || res.playCountTotal == undefined ? 0 :res.playCountTotal;
        let yesterdayIncomeTotal = res.yesterdayIncomeTotal == '' || res.yesterdayIncomeTotal == null || res.yesterdayIncomeTotal == undefined ? 0 :res.yesterdayIncomeTotal;
        let yesterdayPlayCountTotal = res.yesterdayPlayCountTotal == '' || res.yesterdayPlayCountTotal == null || res.yesterdayPlayCountTotal == undefined ? 0 :res.yesterdayPlayCountTotal;
        this.$set(this.bcount,'incomeTotal',incomeTotal)
        this.$set(this.bcount,'copyrightTotal',copyrightTotal)
        this.$set(this.bcount,'playCountTotal',playCountTotal)
        this.$set(this.bcount,'yesterdayIncomeTotal',yesterdayIncomeTotal)
        this.$set(this.bcount,'yesterdayPlayCountTotal',yesterdayPlayCountTotal)
      })
    },
    changePage(v) {
      this.pageNumberD = v;
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      let params = {
        pageNumber: this.pageNumberD,
        pageSize: 10,
        sort: 'create_time',
        order: 'desc',
        copyrightVendorName:this.copyrightVendorNameD,
        copyrightName:this.copyrightNameD
      }
      this.getRequest("/incomeAnalyse/getByPage", params).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      // 以下为模拟数据
      //this.data = [
      //];
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            this.postRequest("/incomeAnalyse/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            this.postRequest("/incomeAnalyse/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    addExcel(){
      this.modalExcelTitle = "导入Excel";
      this.$refs.excelform.resetFields();
      this.modalExcelVisible = true;
    },
    handleExcelSubmit(){
      this.$refs.excelform.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          // 添加 避免编辑后传入id等数据 记得删除
          let formData = new FormData()
          formData.append("excelFile",this.excelform.excelFile)
          console.log('----------------------',this.excelform)
              excelImport(formData).then(res => {
              this.submitLoading = false;
              if (res.code == 200) {
                this.$Message.success("上传成功");
                this.getDataList();
                this.modalExcelVisible = false;
              }else{
                this.$Message.error(res.message)
              }
            });
          }
      });
    },
    uploadFile(event){
      console.log(event.target.files[0].size)
      // this.formToData = formData.get('files')
      this.excelform.excelFile = event.target.files[0]
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.title + " ?",
        loading: true,
        onOk: () => {
          // 删除
          this.deleteRequest("/incomeAnalyse/delByIds/" + v.id).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.getDataList();
            }
          });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          this.deleteRequest("/incomeAnalyse/delByIds/" + ids).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
    #search-form-y{
      margin-top:20px;
      .ivu-form-item-label{
        text-align:center;
      }
    }   
}
</style>